export const getExecutionsAction = () => ({ type: '@GET_EXECUTIONS' });
